<template>
  <el-tag size="small" :type="type">
    {{ title }}
  </el-tag>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'

const QUALITIES: Record<number, string> = {
  0: 'danger',
  1: 'warning',
  2: 'primary',
  3: 'success'
}

export default defineComponent({
  name: 'TrafficLabel',
  props: {
    quality: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const type = computed(() => {
      return QUALITIES[props.quality]
    })
    return { type }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
</style>
